import styled from 'styled-components'

export const Card = styled.div`
  border: 0;
  border-radius: 3px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  padding: 2em;
  margin: 10px;
  background: white;

  p {
    color: black;
    font-family: 'Montserrat';
  }

  .title {
    font-family: Montserrat;
    font-size: 24px;
    font-weight: 500;
  }

  .content {
    color: #111111;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
  }

  .footer {
    color: #FF7300 !important;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
  }
`